/**
 * AMR type integration counts for homepage ticker.
 * Counts reflect active or deployed projects per category.
 * Add images to public/images/amr-types/ (e.g. tugger.png, fork.png).
 * Update these values via CMS/backend or replace this module with an API fetch.
 */
export const amrTypeCounts = [
  { type: "Forklift", count: 35, label: "Forklift", image: "/images/amr-types/forklift.png", width: 422, height: 314 },
  { type: "Tunneler", count: 34, label: "Tunneler", image: "/images/amr-types/tunneler.png", width: 468, height: 278 },
  { type: "Tugger", count: 26, label: "Tugger", image: "/images/amr-types/tugger.png", width: 386, height: 336 },
  { type: "Platform", count: 14, label: "Platform", image: "/images/amr-types/platform.png", width: 492, height: 320 },
  { type: "Pallet", count: 6, label: "Pallet", image: "/images/amr-types/pallet.png", width: 1024, height: 1024 },
];

/**
 * Optional: fetch from backend. Uncomment and wire your API when ready.
 * export async function fetchAmrTypeCounts() {
 *   const res = await fetch('/api/amr-integration');
 *   const data = await res.json();
 *   return data.amrTypeCounts ?? amrTypeCounts;
 * }
 */
